import { render, staticRenderFns } from "./No08.vue?vue&type=template&id=5d3bb112&scoped=true"
import script from "./No08.vue?vue&type=script&lang=js"
export * from "./No08.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3bb112",
  null
  
)

export default component.exports